import styled from 'styled-components';
import { switchProp } from 'styled-tools';
import { fontTitle, fontBody } from 'Styles/fonts';

export const DiscountAppliedMessage = styled.div`
  padding: 0px;
  margin-top: 8px;
  color: var(--destructive);
  border-top: 1px solid var(--border);
  display: flex;
  flex-direction: row;
`;

export const Heading = styled.h2`
  margin: 0;
  margin-bottom: 12px;
  padding: 0;
  ${fontTitle(20)};
  color: var(--foreground);
`;

export const Container = styled.div`
  flex: 1;
  padding: 8px 0px 0px 0px;
  text-align: ${switchProp('align', {
    left: 'left'
  })};
`;

export const Title = styled.h1`
  ${fontTitle(16)};
  margin: 0;
  padding: 0;
`;

export const Subtitle = styled.p`
  ${fontBody(14)};
  margin: 0;
  padding: 0;
  margin-top: 2px;
`;

export const Glyph = styled.div.attrs({ 'aria-hidden': true })`
  font-family: var(--glyph-font), sans-serif;
  font-variant: normal;
  user-select: none;
  color: var(--primary);
  width: 40px;
  text-align: center;
  font-size: 40px;
  margin-right: 8px;
  margin-top: -2px;
`;

export default {};
